import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import {
  CashBalanceDto,
  CashFlowReportDto,
  AddCashTransactionRequest,
} from '../models/finance.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CashService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Cash`;

  getBalance(storeId?: string, currency?: string): Observable<ApiResponse<CashBalanceDto>> {
    let params = new HttpParams();
    if (storeId) params = params.set('storeId', storeId);
    if (currency) params = params.set('currency', currency);
    return this.http.get<ApiResponse<CashBalanceDto>>(`${this.endpoint}/balance`, { params });
  }

  getFlow(
    from: string,
    to: string,
    storeId?: string,
    currency?: string,
  ): Observable<ApiResponse<CashFlowReportDto>> {
    let params = new HttpParams().set('from', from).set('to', to);
    if (storeId) params = params.set('storeId', storeId);
    if (currency) params = params.set('currency', currency);
    return this.http.get<ApiResponse<CashFlowReportDto>>(`${this.endpoint}/flow`, { params });
  }

  addTransaction(data: AddCashTransactionRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(`${this.endpoint}/transaction`, data);
  }
}
